<template>
  <div class="main-wrapper">
    <img src="../assets/negative.png" alt="Одобрено!" height="150px" />
    <p>
      {{
        pageInfo.MESSAGE_BODY != null
          ? pageInfo.MESSAGE_BODY
          : "К сожалению, банк НЕ одобрил вашу заявку."
      }}
    </p>
    <button
      v-if="pageInfo.SHOW_BUTTON_NEXT != null && pageInfo.SHOW_BUTTON_NEXT"
      @click="tryAgain()"
    >
      Пропробовать снова
    </button>
  </div>
</template>

<script>
export default {
  props: {
    pageInfo: {},
  },
  name: "NegativeAnswerPage",
  methods: {
    tryAgain() {
      this.$emit("tryAgain", { INN: this.pageInfo.INN, ID: this.pageInfo.ID });
    },
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: center;
}
button {
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  border: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 20px;
  outline: none;
  color: white;
  background-color: #06569b;
  cursor: pointer;
}
button:hover {
  background-color: #0c63af;
}
</style>